export const COLORS = {
  PRIMARY: {
    BLUE: {
      MAIN: '#263465',
      '+6': '#292F36',
      '+5': '#061445',
      '+4': 'rgba(16, 119, 185, 0.08)',
      '+3': '#083a5d',
      '+2': 'rgba(16, 119, 185, 0.24)',
      '+1': '#337ab7',
      '-1': '#2580ac',
      '-2': '#0b5583',
      '-3': '#229DEC',
      '-4': '#1077b9',
      '-5': '#1ebfff',
      '-6': '#79cfe5',
      '-7': '#527179',
    },
  },
  PURPLE: {
    MAIN: '#677193',
  },
  RED: {
    MAIN: '#EE0020',
    '-1': '#eb6565',
  },
  ORANGE: {
    MAIN: '#FFAA00',
    '+1': '#f5a123',
    '-1': '#f4c02b',
  },
  GREEN: {
    MAIN: '#00AA00',
    '+1': '#3B873E',
    '-1': '#21c756',
    '-2': '#50e3c2',
  },
  WHITE: '#FFF',
  BLACK: '#000',
  DARK: {
    MAIN: 'rgba(0, 0, 0, 0.38)',
    '+5': 'rgba(0, 0, 0, 0.87)',
    '+4': 'rgba(0, 0, 0, 0.6)',
    '+3': 'rgba(0, 0, 0, 0.54)',
    '+2': 'rgba(0, 0, 0, 0.5)',
    '+1': 'rgba(0, 0, 0, 0.42)',
    '-1': 'rgba(0, 0, 0, 0.3)',
    '-2': 'rgba(0, 0, 0, 0.2)',
    '-3': 'rgba(255,255,255,0)',
    '-4': 'rgba(0, 0, 0, 0.1)',
    '-5': 'rgba(255, 255, 255, 0.1)',
    '-6': 'rgba(0, 0, 0, 0.14)',
    '-7': 'rgba(0, 0, 0, 0.12)',
  },
  LIGHT: {
    MAIN: '#f0f0f0',
    '+2': 'rgba(255,255,255,0.6)',
    '+1': 'rgb(187, 184, 184)',
    '-1': 'rgba(255,255,255,1)',
  },
  GRAY: {
    MAIN: '#616161',
    '+11': '#171717',
    '+10': '#303030',
    '+9': '#282828',
    '+8': '#2a2a2a',
    '+7': '#404040',
    '+6': '#818181',
    '+5': '#909090',
    '+4': '#9b9b9b',
    '+3': '#999999',
    '+2': '#9e9e9e',
    '+1': '#a0a0a0',
    '-1': '#BBBBBB',
    '-2': '#606060',
    '-3': '#B2B2B2',
    '-4': '#c0c0c0',
    '-5': '#CCCCCC',
    '-6': '#c4c4c4',
    '-7': '#dadada',
    '-8': '#e0e0e0',
    '-9': '#757575',
    '-10': '#E1E1E1',
    '-11': '#eaeaea',
    '-12': '#EEEEEE',
  },
};
